import {Button, Typography} from "@mui/material";
import axios from "axios";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {alert} from "src/services/alert";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";
import QRCode from "qrcode";
import {H5_PAGE_URL_PROD, IMG_BASE_URL} from "src/config/constants";
import {asyncRequest} from "src/services/network";

const LookCodeDialog = ({merchant, open, onClose}) => {
  const [uri, setUri] = useState("");
  const [titleDialog, setTitleDialog] = useState("未知");
  useEffect(() => {
    if(merchant&&merchant.merchant&&merchant.merchant.name){
      setTitleDialog(merchant.merchant.name)
    }
    // let dddd = `${H5_PAGE_URL_PROD}/#/pages/store-payment/store-payment?mid=${merchant.mid}`
    let qrcodeUrl = merchant.qrcodeUrl
    console.log(qrcodeUrl)
    if (!merchant) return;
    QRCode.toDataURL(qrcodeUrl, {
      width: 256,
      height: 256,
      margin: 0
    })
      .then(uri => {
        // console.log(uri);
        setUri(uri);
      })
      .catch(err => {
        console.error(err)
      })

    // getMerchantCode();
  }, []);

  async function getMerchantCode() {
    const {data} = await asyncRequest({
      // method: 'get',
      path: "/merchant/getQrcode",
      data: {mid: merchant.mid},
    });

    // setUri(data);
    generateQrcode(data);
  }

  function generateQrcode(base64) {
    const that = this;
    const canvas = document.createElement("canvas");
    canvas.width = 480;
    canvas.height = 480;
    // const canvas = wx.createOffscreenCanvas({type: '2d', width: 600, height: 750})
    // console.log(canvas)
    const ctx = canvas.getContext("2d");

    const image = new Image();
    const logo = new Image();
    image.onload = () => {
      ctx.drawImage(image, 0, 0);

      function setupClipPath() {
        ctx.beginPath();
        const targetX = 135;
        const targetY = 135;
        const size = 210;
        const halfWidth = size / 2;
        const halfHeight = size / 2;
        const width = size;
        const height = size;
        const borderRadius = halfWidth;

        const topCenter = {
          x: targetX + halfWidth,
          y: targetY,
        };
        const topRight = {
          x: targetX + width,
          y: targetY,
        };
        const rightCenter = {
          x: targetX + width,
          y: targetY + halfHeight,
        };
        const bottomRight = {
          x: targetX + width,
          y: targetY + height,
        };
        const bottomCenter = {
          x: targetX + halfWidth,
          y: targetY + height,
        };
        const bottomLeft = {
          x: targetX,
          y: targetY + height,
        };
        const leftCenter = {
          x: targetX,
          y: targetY + halfHeight,
        };
        const topLeft = {
          x: targetX,
          y: targetY,
        };

        ctx.moveTo(topCenter.x, topCenter.y);
        ctx.arcTo(topRight.x, topRight.y, rightCenter.x, rightCenter.y, borderRadius);
        ctx.arcTo(bottomRight.x, bottomRight.y, bottomCenter.x, bottomCenter.y, borderRadius);
        ctx.arcTo(bottomLeft.x, bottomLeft.y, leftCenter.x, leftCenter.y, borderRadius);
        ctx.arcTo(topLeft.x, topLeft.y, topCenter.x, topCenter.y, borderRadius);
        ctx.closePath();
        ctx.clip();
      }

      logo.onload = () => {
        setupClipPath();
        ctx.drawImage(logo, 135, 135, 210, 210);

        const uri = ctx.canvas.toDataURL("PNG", 1);
        console.log(uri)
        setUri(uri);
        // saveCanvas(ctx);
      };
      logo.crossOrigin = "anonymous";
      logo.src = `${IMG_BASE_URL}${merchant.logo}`;
    };
    image.crossOrigin = "anonymous";
    image.src = `data:image/png;base64,${base64}`;
  }

  function saveCanvas(ctx) {
    const base64 = ctx.canvas.toDataURL("PNG", 1);
    // console.log('saving', this.data.frame)
  }

  return (
    <FormDialog title={titleDialog} open={open} onClose={onClose} onConfirm={onClose}>
      <Typography>{merchant?.name}</Typography>
      <img src={uri} style={{maxWidth: 300}}/>
      {/* <Button onClick={getMerchantCode}>小程序码</Button> */}
    </FormDialog>
  );
};

export default LookCodeDialog;
